var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveReturnsNavbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48798 0.70443C6.13527 0.351779 5.56341 0.351779 5.2107 0.70443L1.12197 4.79248C0.951648 4.95672 0.845703 5.18726 0.845703 5.44254C0.845703 5.53397 0.859296 5.62224 0.884572 5.70542C0.926259 5.84297 1.00148 5.97254 1.11024 6.08128C1.29156 6.26257 1.53081 6.35067 1.76842 6.34556H22.2512C22.75 6.34556 23.1544 5.94126 23.1544 5.44254C23.1544 4.94381 22.75 4.53952 22.2512 4.53952H3.92953L6.48798 1.98149C6.84069 1.62884 6.84069 1.05708 6.48798 0.70443Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2512 9.65412H1.74887C1.25007 9.65412 0.845703 10.0584 0.845703 10.5571C0.845703 11.0559 1.25007 11.4602 1.74887 11.4602H20.0721L17.5134 14.0184C17.1607 14.371 17.1607 14.9428 17.5134 15.2955C17.8661 15.6481 18.438 15.6481 18.7907 15.2955L22.8912 11.1957C23.2439 10.843 23.2439 10.2713 22.8912 9.9186C22.7147 9.74213 22.4826 9.65396 22.2512 9.65412Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveReturnsNavbarIcon);
export default __webpack_public_path__ + "static/media/inactive-returns-navbar-icon.1c35124f1dfb2da2ab0b177323f3e611.svg";
export { ForwardRef as ReactComponent };